// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"8b148fa1","349":"93656129","530":"a8e60550","569":"aa2459f6","589":"55ab817f","654":"8661497b","671":"b0e0069a","714":"8300380e","796":"10bca5ec"}[chunkId] + ".css";
};